import React, { useState } from 'react';
import useFetch from 'components/shared/hooks/useFetch';
import Select from 'components/shared/select';
import { routes } from 'constants/config';
import { Spinner } from 'ui';
import { setQueryStringForCurrentUrl, getQueryParam } from 'utils/url';
import Sidebar from './Sidebar';
import Header from './Header';
import ScenarioEngagementContainer from './ScenarioEngagementContainer';
import ConversationInteractionPerformance from './ConversationInteractionPerformance';

const OnDemandPracticeOverview = ({ scenarioId, permissions }) => {
  const queryGroupId = getQueryParam(window.location.href, 'group_id');
  const [{ groups }, setGroups] = useState({ groups: null });
  const [groupId, setGroupId] = useState(queryGroupId || null);
  const [scenario, updateScenario] = useState({});
  const { scenarioType } = scenario;
  const { initialLoading } = useFetch(
    routes.ON_DEMAND_PRACTICE.CREATOR.SHOW(scenarioId, groupId),
    updateScenario,
  );

  const updateGroup = e => {
    const gId = e.target.value || null;
    setQueryStringForCurrentUrl(gId ? `group_id=${gId}` : '');
    setGroupId(gId);
    e.target.blur();
  };

  const { groupsLoading } = useFetch(routes.GROUPS, setGroups);

  return (
    <div className="PathBuilder">
      {initialLoading && <Spinner />}
      {!initialLoading && (
        <>
          <div className="PathBuilder-main">
            <div className="PathViewer">
              <Header
                scenario={scenario}
                userCanEditScenario={permissions.userCanEditScenario}
              />
              {permissions.userCanManageUsers && (
                <div className="d-f ai-c mt-16">
                  <div className="f-sh-0 mr-8 c-gray-darker">
                    {t('common.filter_by')}
                  </div>
                  <Select
                    value={groupId}
                    onChange={updateGroup}
                    disabled={groupsLoading}
                    className="w-240"
                  >
                    {groupsLoading && <option>{t('common.loading')}</option>}
                    {!groupsLoading && (
                      <>
                        <option key="none" value="">
                          {t('groups.select')}
                        </option>
                        {groups &&
                          groups.map(({ id, name }) => (
                            <option key={id} value={id}>
                              {name}
                            </option>
                          ))}
                      </>
                    )}
                  </Select>
                </div>
              )}
              {permissions.userCanManageUsers && (
                <>
                  <ScenarioEngagementContainer
                    groupId={groupId}
                    scenarioId={scenarioId}
                  />
                  {scenarioType === 'conversation' && (
                    <ConversationInteractionPerformance
                      scenario={scenario}
                      groupId={groupId}
                    />
                  )}
                </>
              )}
            </div>
          </div>
          <div className="PathBuilder-side">
            <Sidebar
              scenario={scenario}
              updateScenario={updateScenario}
              userCanEditScenario={permissions.userCanEditScenario}
              userCanManageUsers={permissions.userCanManageUsers}
            />
          </div>
        </>
      )}
    </div>
  );
};

export default props => <OnDemandPracticeOverview {...props} />;
